import { createSelector } from 'reselect';

const getById = state => state.notifications.byId;
const getIdList = state => state.notifications.idList;
export const getCount = state => (state.viewMode === 'editor' ? 5 : state.notifications.metadata.count);

const sortNotifications = notifications =>
  notifications.sort((a, b) => {
    if (!a.createdDate) {
      return 1;
    }
    return new Date(b.createdDate) - new Date(a.createdDate);
  });

export const getNotifications = createSelector([getById, getIdList], (byId, idList) =>
  sortNotifications(idList.map(id => byId[id]))
);



// WEBPACK FOOTER //
// ./app/selectors/notification-selectors.js